import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=427dbf5d&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.css?vue&type=style&index=0&id=427dbf5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427dbf5d",
  null
  
)

export default component.exports